import dayjs from "dayjs";
import dayjsTimezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import store from "../store/store";
import { SessionHelper } from "./sessionHelper";

/**
    Helper class for time and date operations.
  */
export class TimeDateHelper {
  /**
    Returns the current UTC time formatted according to the specified format.
    @param format - The format string for the desired output.
    @returns The formatted UTC date and time.
    */
  static getUTCFormattedDateTime(format: string) {
    dayjs.extend(utc);

    return dayjs().utc().format(format);
  }

  static getFormattedDateTime(date: string, format: string) {
    const userTimezone = store.getState().userModel.timezone;
    dayjs.extend(utc);
    dayjs.extend(dayjsTimezone);
    if (!date) {
      return;
    }
    const dateRoot = SessionHelper.isAsianRouteAndSessionView()
      ? dayjs(date).tz(userTimezone.name)
      : dayjs(date);
    return dateRoot.format(format);
  }
}
